<ng-template #content>
    @if (image()?.url) {
        <cms-image class="module-chip__icon" [media]="image()" />
    }
    <span class="module-chip__label">{{ label() }}</span>
    @if (expandable()) {
        <mat-icon class="module-chip__arrow">keyboard_arrow_down</mat-icon>
    }
</ng-template>

@if (expandable()) {
    <button
        class="module-chip module-chip--button"
        type="button"
        [class.module-chip--expanded]="expanded()"
        [attr.aria-expanded]="expanded()"
        (click)="toggled.emit()"
    >
        <ng-container [ngTemplateOutlet]="content" />
    </button>
} @else {
    <span class="module-chip" [class.module-chip--tag]="variant() === 'tag'">
        <ng-container [ngTemplateOutlet]="content" />
    </span>
}
